import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import './Main.css';
import Store from './Store';
import Banner from './Banner';
import Logo from './holding/Logo';
import Footer from './Footer';
import checkmark from '../check-lite.png';

export default function Main() {
  const { id } = useParams();
  const [store, setStore] = useState(null);
  const [customerPhone, setCustomerPhone] = useState(null);
  const fetchStoreComplete = useRef(false);

  useEffect(() => {
    if (fetchStoreComplete.current === false) {
      fetch(`https://leadsherpapost.com/qc/api/v1/getapp/${id}`)
        .then((response) => response.json())
        .then((data) => {
          setStore(data.store);
          setCustomerPhone(data.phone);
          fetchStoreComplete.current = true;
        });
    }
  }, [id, store]);

  return (
    <div>
      <div className="apply-now">
        <Logo />
        <div className="main">
          <div className="container">
            <Banner
              store={store}
              customerPhone={customerPhone}
            ></Banner>
          </div>
          <div className="pt-5 pb-3"></div>
          {store ? (
            <div className="container">
              <Store store={store}></Store>
            </div>
          ) : (
            ''
          )}
          <div className="container pb-5">
            <div className="process-title gray-bg">
              <strong>The process is easy!</strong>
            </div>
            <div className="row gray-bg">
              <div className="col-lg-9">
                <div className="pt-1 pb-2 row">
                  <div className="col-1">
                    <img
                      src={checkmark}
                      alt="check"
                      width="30"
                      height="30"
                    />
                  </div>
                  <div className="col-11 pt-1">
                    Speak with a customer service representative to
                    make an appointment.
                  </div>
                </div>
              </div>
            </div>
            <div className="row gray-bg">
              <div className="col-lg-9">
                <div className="pt-1 pb-2 row">
                  <div className="col-1">
                    <img
                      src={checkmark}
                      alt="check"
                      width="30"
                      height="30"
                    />
                  </div>
                  <div className="col-11 pt-1">
                    Visit your local store to complete your
                    application.
                  </div>
                </div>
                <div className="pt-1 pb-2 row">
                  <div className="col-1">
                    <img
                      src={checkmark}
                      alt="check"
                      width="30"
                      height="30"
                    />
                  </div>
                  <div className="col-11 pt-1">Get Approved!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
